import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Container, Box, Typography, Grid, Divider, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Hero from '../components/Hero';
import services from '../content_stub/services_content.js';
import { SEO } from '../utils/seo';
import { buildServiceJsonLd } from '../utils/seo';
import { base } from '../seo/keywords';

export default function ServiceDetails() {
  const { slug } = useParams();
  const service = services.find(s => s.slug === slug);

  if (!service) {
    return (
      <Container sx={{ py: 6 }}>
        <Typography variant="h3">Service Not Found</Typography>
        <Button component={RouterLink} to="/services" sx={{ mt: 2 }} variant="contained">Back to Services</Button>
      </Container>
    );
  }

  const title = `${service.title} in Bloomington IN | Rite HVAC Services`;
  const description = `${service.title} by certified technicians. Serving Bloomington, Ellettsville, Bedford, Martinsville, and Spencer.`;
  const canon = base + '/services/' + service.slug;

  const jsonLd = [buildServiceJsonLd(service.title, canon)];

  return (
    <Box>
      <SEO title={title} description={description} canonical={canon} jsonLd={jsonLd} openGraph={{ image: service.heroImage }} />
      <Hero title={service.title} subtitle={service.summary} bgImage={service.heroImage} ctaText="Book This Service" ctaLink="/book" />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Typography variant="h2" gutterBottom>Overview</Typography>
            <Typography paragraph>{service.body}</Typography>
            <Divider sx={{ my: 3 }} />
            <Typography variant="h3" gutterBottom>Pricing Guidance</Typography>
            <Typography paragraph>{service.pricing}</Typography>
            <Typography variant="h3" sx={{ mt: 4 }} gutterBottom>Local Service Areas</Typography>
            <Typography paragraph>
              We proudly serve Bloomington IN and nearby areas: Ellettsville, Bedford, Martinsville, and Spencer.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2 }}>
              <Typography variant="h6">Questions About {service.title}?</Typography>
              <Typography variant="body2" color="text.secondary">Call us 24/7 at (812) 555-0168 or book online.</Typography>
              <Button fullWidth sx={{ mt: 2 }} variant="contained" href="/book">Request Service</Button>
            </Box>
            <Box sx={{ mt: 3, p: 2, border: '1px solid #eee', borderRadius: 2 }}>
              <Typography variant="h6">Maintenance Tips</Typography>
              <ul>
                <li>Replace filters regularly and keep outdoor units clear of debris.</li>
                <li>Schedule seasonal tune-ups to maintain peak efficiency.</li>
                <li>Ask about smart thermostats and zoning for better comfort control.</li>
              </ul>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 6 }}>
          <Typography variant="h3" gutterBottom>FAQs</Typography>
          {service.faqs.map((f, i) => (
            <Accordion key={i}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography>{f.q}</Typography></AccordionSummary>
              <AccordionDetails><Typography>{f.a}</Typography></AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
